import { OpenAlertPayload } from 'common/store/client/global-alert/use-global-alert.store';

export const CONFIRMATION_MESSAGE = 'You have unsaved changes. Continue?';

export const DEVICE_ACTIVATION_SWITCH_WARNING: OpenAlertPayload = {
  text: 'At least one desktop or mobile layout should be activated, for widget to appear on page',
  severity: 'warning',
};
